// Small pure helpers for the /margin step. Kept out of the component so Home.jsx
// can use them without importing the component (the wizard imports its steps, and
// the steps import the wizard for its context -- one cycle is enough).

/** The server answers in { id, en }; a plain string passes through. */
export function plainMessage(message, lang) {
    if (message && typeof message === 'object') return message[lang] || message.en || message.id || '';
    return message || '';
}

/**
 * Is this marital status the one called "married"?
 *
 * Found by name in the options the wizard loaded from the master, never by
 * assuming an id: the master is KSEI-coded and the form elsewhere compares to a
 * literal "2", which is right today and silently wrong the day the codes change.
 *
 * @param maritalStatus  a value, or an option object { value, label }
 * @param options        [{ value, label }] from state.master.master_marital_status
 */
export function isMarried(maritalStatus, options) {
    const value = (maritalStatus && typeof maritalStatus === 'object') ? maritalStatus.value : maritalStatus;
    if (value === undefined || value === null || String(value) === '') return false;
    const married = (options || []).find((o) => String(o.label).trim().toLowerCase() === 'married');
    return !!married && String(married.value) === String(value);
}

/** Has the client actually picked something from a select? Works for '', null, a string or an option object (including one whose value is empty). */
export function hasPicked(value) {
    if (value && typeof value === 'object') return String(value.value || '') !== '';
    return value !== undefined && value !== null && String(value).trim() !== '';
}

/**
 * What the identity step should do with a returning client who arrived by /margin.
 * The server has the final word on every one of these (controllers/margin.js); this
 * only decides which of the client's screens to show, in the same order the server
 * checks them.
 *
 *   closed              /margin is not open, or has not yet been found to be
 *   already_submitted   an application is already in
 *   regular_incomplete  the Regular Account is not finished (no submission, RDN number or NAIK)
 *   check               ask the server whether this client may apply
 */
export function marginGate({ open, margin_submitted, isSubmitted, hasRDNNumber, naikSubmitted }) {
    if (open !== true) return 'closed';
    if (parseInt(margin_submitted) === 1) return 'already_submitted';
    if (!isSubmitted || !hasRDNNumber || !naikSubmitted) return 'regular_incomplete';
    return 'check';
}

export const MARGIN_BANK_LABELS = { bca: 'BCA', permata: 'Permata', cimb: 'CIMB', bri: 'BRI' };
